import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as API } from '../../../axiosConfig';

const URL = '/auth/';

const SLICE_NAME = 'userManagementUsers';
const LIST_USER_MANAGEMENT_USERS = `${SLICE_NAME}/user-management/users/list`;
const CREATE_USER_MANAGEMENT_USER = `${SLICE_NAME}/user-management/users/create`;
const UPDATE_USER_MANAGEMENT_USER = `${SLICE_NAME}/user-management/users/update`;
const DELETE_USER_MANAGEMENT_USER = `${SLICE_NAME}/user-management/users/delete`;

export const getUserManagementUserList = createAsyncThunk(
  LIST_USER_MANAGEMENT_USERS,
  async (_, { rejectWithValue }) => {
    const url = `${URL}users`;

    try {
      const {
        data: { data },
      } = await API.get(url);

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createUser = createAsyncThunk(
  CREATE_USER_MANAGEMENT_USER,
  async (payload) => {
    const url = `${URL}signup`;

    const response = await API.post(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const updateUser = createAsyncThunk(
  UPDATE_USER_MANAGEMENT_USER,
  async ({ id, ...payload }) => {
    const url = `${URL}user/${id}`;

    const response = await API.put(url, payload).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

export const deleteUser = createAsyncThunk(
  DELETE_USER_MANAGEMENT_USER,
  async ({ id }) => {
    const url = `${URL}user/${id}`;

    const response = await API.delete(url).catch((error) => {
      console.error(JSON.stringify(error));
      return error && error.response;
    });

    return response.data;
  },
);

const initialState = {
  userList: [],
  userListStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed',
};

const userManagementUsersSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserManagementUserList.pending, (state) => {
        state.userListStatus = 'loading';
      })
      .addCase(getUserManagementUserList.rejected, (state) => {
        state.userList = [];
        state.userListStatus = 'failed';
      })
      .addCase(getUserManagementUserList.fulfilled, (state, { payload }) => {
        state.userList = payload;
        state.userListStatus = 'succeeded';
      });
  },
});

export const userManagementUsersActions = userManagementUsersSlice.actions;

export const selectUserManagementUsersList = (state) =>
  state.userManagement.users.userList;

export const selectIsLoadingUserManagementUsersList = (state) =>
  state.userManagement.users.userListStatus === 'loading';

export default userManagementUsersSlice.reducer;
